"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.disableAttributesIfRestricted = void 0;
const AttributeRestriction_1 = require("../models/AttributeRestriction");
const lodash_clonedeep_1 = __importDefault(require("lodash.clonedeep"));
const disableAttributesIfRestricted = function (attributes) {
  let restrictions = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  let selectedOptions = arguments.length > 2 ? arguments[2] : undefined;
  if (restrictions.length === 0) {
    return attributes;
  }
  const restrictedAttributeSet = restrictions.reduce((attrs, restriction) => {
    // The disable property of AttributeRestrictions could be one of two shapes:
    // https://github.com/ArtifactUprising/au-js-sdk/blob/master/src/models/AttributeRestriction.ts#L11
    if ((0, AttributeRestriction_1.isAttrRestriction)(restriction.disable)) {
      // TODO: if all options are disabled, also remove the option
      if (attrs[restriction.if.attribute] && selectedOptions[restriction.if.attribute] === restriction.if.equals) {
        // eslint-disable-next-line no-param-reassign
        delete attrs[restriction.disable.attribute];
      }
      return attrs;
    } else {
      const safeDisable = restriction.disable;
      if (safeDisable.optionsFor && attrs[safeDisable.optionsFor] && selectedOptions[restriction.if.attribute] === restriction.if.equals) {
        return Object.assign(Object.assign({}, attrs), {
          [safeDisable.optionsFor]: Object.assign(Object.assign({}, attrs[safeDisable.optionsFor]), {
            options: attrs[safeDisable.optionsFor].options.map(opt => {
              if (safeDisable.options.includes(opt.value)) {
                return Object.assign(Object.assign({}, opt), {
                  disabled: true
                });
              }
              return opt;
            })
          })
        });
      }
      return attrs;
    }
  }, (0, lodash_clonedeep_1.default)(attributes));
  // if there are any option sets that have no enabled options, remove them
  Object.keys(restrictedAttributeSet).forEach(attrKey => {
    if (restrictedAttributeSet[attrKey].options.every(o => !!o.disabled)) {
      delete restrictedAttributeSet[attrKey];
    }
  });
  return restrictedAttributeSet;
};
exports.disableAttributesIfRestricted = disableAttributesIfRestricted;